import React from "react";
import { Button, Menu, MenuItem, Tooltip } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { FaCalendarDays } from "react-icons/fa6";
import { BsPeopleFill, BsQrCodeScan } from "react-icons/bs";
import { MdEmail, MdVideoLibrary, MdAddPhotoAlternate } from "react-icons/md";
import { LuImage, LuImagePlus } from "react-icons/lu";

const EventCards = ({
  viewevent,
  handleClick,
  handleClose,
  handleedit,
  handledelete,
  handleshowqr,
  handleAddMedia,
  anchorEl,
  t,
}) => {
  return (
    <div className="w-full grid 2xl:grid-cols-3 lg:grid-cols-2 gap-6">
      {viewevent?.data?.map((items) => (
        <div
          key={items.id}
          className="relative w-full bg-white rounded-xl p-5 flex flex-col gap-5 
          border border-gray-200 hover:border-blue-100 hover:shadow-lg transition-all duration-300 group"
          style={{
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
          }}
        >
          {/* Top-right Menu Button */}
          <div className="absolute top-4 right-4">
            <Button
              id="basic-button"
              aria-controls={anchorEl[items.id] ? "basic-menu" : undefined}
              disableRipple
              aria-haspopup="true"
              sx={{
                background: "transparent",
                minWidth: "auto",
                padding: "4px",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "rgba(54, 134, 255, 0.08)",
                },
              }}
              onClick={(e) => handleClick(e, items.id)}
            >
              <MoreVertIcon className="text-gray-500 hover:text-[#3686FF] transition-colors duration-200" />
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl[items.id]}
              open={Boolean(anchorEl[items.id])}
              onClose={() => handleClose(items.id)}
              MenuListProps={{ "aria-labelledby": "basic-button" }}
              sx={{
                "& .MuiPaper-root": {
                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
                  borderRadius: "12px",
                  border: "1px solid #f0f0f0",
                  paddingX: "8px",
                  paddingY: "0px",
                },
              }}
            >
              <MenuItem
                onClick={() => handleedit(items)}
                sx={{
                  borderRadius: "8px",
                  fontSize: "14px",
                  padding: "8px 12px",
                  margin: "2px 0",
                  "&:hover": {
                    backgroundColor: "rgba(54, 134, 255, 0.08)",
                  },
                }}
              >
                <EditIcon sx={{ marginRight: 1.5, color: "#3686FF", fontSize: "20px" }} />
                {t("menu_edit")}
              </MenuItem>
              <MenuItem
                onClick={() => handledelete(items.id)}
                sx={{
                  borderRadius: "8px",
                  fontSize: "14px",
                  padding: "8px 12px",
                  margin: "2px 0",
                  "&:hover": {
                    backgroundColor: "rgba(237, 57, 57, 0.08)",
                  },
                }}
              >
                <DeleteIcon sx={{ marginRight: 1.5, color: "#ED3939", fontSize: "20px" }} />
                {t("menu_delete")}
              </MenuItem>
            </Menu>
          </div>

          {/* Header Section */}
          <div className="flex items-start gap-4">
            <div
              className="bg-gradient-to-br from-[#3686FF] to-[#4A9AFF] rounded-lg p-3 shadow-sm flex-shrink-0"
              style={{ boxShadow: "0px 4px 12px rgba(54, 134, 255, 0.2)" }}
            >
              <FaCalendarDays className="text-white text-xl" />
            </div>
          </div>
          <div className="flex flex-col">
            <span className="font-semibold text-gray-800 text-lg leading-tight line-clamp-2">
              {items.name}
            </span>
            <span className="text-[#3686FF] text-md font-medium mt-1">
              {items.category.name}
            </span>
          </div>

          {/* Date Section */}
          <div className="bg-blue-50 rounded-lg p-3 border border-blue-100">
            <span className="text-gray-600 text-xs font-medium block mb-1">
              {t("date")}
            </span>
            <span className="text-gray-800 text-sm font-semibold">
              {new Date(items.date).toLocaleDateString(
                `${localStorage.getItem("i18nextLng") === "fr" ? "fr-FR" : "en-US"}`,
                {
                  weekday: "short",
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                }
              )}
            </span>
          </div>

          {/* Stats Section */}
          <div className="grid grid-cols-4 gap-2">
            {/* Guests */}
            <Tooltip
              title={`${t("guest_count")}: ${items.guest_count}`}
              placement="top"
              slotProps={{
                tooltip: {
                  placement: "top",
                  className: "custom-tooltip",
                },
              }}
            >
              <div
                className="group flex flex-col items-center justify-center bg-white border border-gray-200 rounded-lg text-center p-3 cursor-pointer hover:border-blue-500 hover:shadow-sm transition-all duration-200"
                role="region"
              >
                <div className="flex items-center justify-center gap-2">
                  <BsPeopleFill className="text-gray-600  text-lg transition-colors duration-200" />
                  <span className="text-gray-800 text-md font-semibold">{items.guest_count}</span>
                </div>
                {/* <span className="text-gray-500 text-xs block mt-1">{t("guest_count")}</span> */}
              </div>
            </Tooltip>

            {/* Emails */}
            <Tooltip
              title={`${t("review_requests")}: ${items.review_requests}`}
              placement="top"
              slotProps={{
                tooltip: {
                  placement: "top",
                  className: "custom-tooltip",
                },
              }}
            >
              <div
                className="group flex flex-col items-center justify-center bg-white border border-gray-200 rounded-lg text-center p-3 cursor-pointer hover:border-blue-500 hover:shadow-sm transition-all duration-200"
                role="region"
              >
                <div className="flex items-center justify-center gap-2">
                  <MdEmail className="text-gray-600  text-lg transition-colors duration-200" />
                  <span className="text-gray-800 text-md font-semibold">{items.review_requests}</span>
                </div>
                {/* <span className="text-gray-500 text-xs block mt-1">{t("review_requests")}</span> */}
              </div>
            </Tooltip>

            {/* Videos */}
            <Tooltip
              title={`${t("recieved_reviews")}: ${items.recieved_reviews}`}
              placement="top"
              slotProps={{
                tooltip: {
                  placement: "top",
                  className: "custom-tooltip",
                },
              }}
            >
              <div
                className="group flex flex-col items-center justify-center bg-white border border-gray-200 rounded-lg text-center p-3 cursor-pointer hover:border-blue-500 hover:shadow-sm transition-all duration-200"
                role="region"
              >
                <div className="flex items-center justify-center gap-2">
                  <MdVideoLibrary className="text-gray-600  text-lg transition-colors duration-200" />
                  <span className="text-gray-800 text-md font-semibold">{items.recieved_reviews}</span>
                </div>
                {/* <span className="text-gray-500 text-xs block mt-1">{t("recieved_reviews")}</span> */}
              </div>
            </Tooltip>

            {/* QR Code */}
            <div
              className="group bg-white border border-gray-200 rounded-lg text-center p-3 cursor-pointer hover:border-blue-500 hover:shadow-sm transition-all duration-200 flex flex-col items-center justify-center"
              role="region"
              onClick={() => handleshowqr(items)}
            >
              <BsQrCodeScan className="  text-xl transition-colors duration-200 text-center" />
              {/* <span className="text-gray-500 text-xs block mt-1">{t("qr_code")}</span> */}
            </div>
          </div>

          {/* Add Media Button */}
          <div className="flex gap-3 w-full">
            <button
              className="w-full border border-blue-500 text-blue-500 rounded-lg py-3 px-5 flex items-center justify-center gap-3 font-normal bg-blue-100 hover:border-blue-600 hover:text-blue-600 focus:ring-2 focus:ring-blue-300 focus:ring-offset-2 transition-all duration-300 group/button"
              onClick={() => handleAddMedia(items.id)}
            >
              <LuImagePlus size={20} className="" />
              <span>{t("add_media")}</span>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EventCards;